import React from 'react'
import { trans } from '../../../../../Utils'

function WorkForm() {
  return (
    <div>{trans({ id: "emp_wo_fo", defaultMessage: "not entered" })}</div>
  )
}

export default WorkForm